import classNames from 'classnames';
import { t } from '@lingui/macro';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Checkbox from '@components/common/checkbox/main';

function OrientationFilter({ orientation, updateFilters }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen((prev) => !prev);

  return (
    <fieldset className={classNames(
      "filter-section",
      "cx-filters-orientationaccordion-section",
      "accordion-section",
      "orientation"
    )}>
      <legend className="accordion-title">Orientation</legend>
      <div
        className="flex-row accordion-tab"
        onClick={toggleOpen}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleOpen();
          }
        }}
        aria-expanded={isOpen}
      >
        <span className="accordion-title-spacer">Orientation</span>
        <span
          className={`bff-caret-down ${isOpen ? 'open' : ''} `}
          aria-hidden="true"
        />
      </div>
      <div className={`accordion-content ${isOpen ? 'open' : 'closed'}`}>
        {isOpen && (
          <React.Fragment>
            <div className="flex-row">
              <Checkbox
                checked={orientation.indexOf('landscape') > -1}
                label={t`Horizontal`}
                size="sm"
                toggle={() => updateFilters("landscape")}
              />
              <div className="icon-holder">
                <span className="bff-horizontal-orientation" />
              </div>
            </div>
            <div className="flex-row">
              <Checkbox
                checked={orientation.indexOf('portrait') > -1}
                label={t`Vertical`}
                size="sm"
                toggle={() => updateFilters("portrait")}
              />
              <div className="icon-holder">
                <span className="bff-vertical-orientation" />
              </div>
            </div>
            <div className="flex-row">
              <Checkbox
                checked={orientation.indexOf('square') > -1}
                label={t`Square`}
                size="sm"
                toggle={() => updateFilters("square")}
              />
              <div className="icon-holder">
                <span className="bff-square-orientation" />
              </div>
            </div>
            <div className="flex-row">
              <Checkbox
                checked={orientation.indexOf('panorama') > -1}
                label={t`Panoramic`}
                size="sm"
                toggle={() => updateFilters("panorama")}
              />
              <div className="icon-holder">
                <span className="bff-panoramic-orientation" />
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </fieldset>
  );
}

OrientationFilter.propTypes = {
  orientation: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateFilters: PropTypes.func.isRequired,
};

export default OrientationFilter;
